import { render, staticRenderFns } from "./SmsListComponent.vue?vue&type=template&id=2161e0aa&"
import script from "./SmsListComponent.vue?vue&type=script&lang=js&"
export * from "./SmsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports